import React, { useState, useEffect } from 'react'
import { BotIcon } from '../../conf/images'
import './index.css'
import { IonPage, IonContent, IonButton, IonAlert } from '@ionic/react'
import { useHistory } from 'react-router'
import { BotModel } from '../../model/bot.model'
import { botRemove, installStoreBot, getMyBots } from '../../service/api/bot'
import { BotKnowledgesPage } from '../../conf/routePath'
import Toast from '../../components/Toast'
import Header from '../../components/Header'

/** 应用详情 */
let udpateTimer: any = null
const BotDetail = () => {
    const history = useHistory<{ bot: BotModel; isStore: boolean }>()
    const { bot, isStore } = history.location.state || {}
    const [alertOptions, setAlertOptions] = useState({
        isOpen: false,
        onDidDismiss: () => {
            setAlertOptions({
                ...alertOptions,
                isOpen: false,
            })
        },
        message: '确认移除该机器人？',
    })
    const [toast, setToast] = useState({
        isOpen: false,
        message: '',
    })
    const [botInfo, setBotInfo] = useState(bot)
    useEffect(() => {
        setBotInfo(bot)
    }, [bot])
    useEffect(() => {
        queryMyBots()
        return () => {
            clearTimeout(udpateTimer)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    if (!botInfo) return null
    /** 确认移除用户机器人 */
    const handleBotRemove = async () => {
        try {
            let res = await botRemove(botInfo.id)
            console.log(res)
            if (res) {
                history.goBack()
            }
        } catch (error) {
            console.error(error)
        }
    }
    /** 更新机器人 */
    const handleBotAddOrUpdate = async (botId: string) => {
        try {
            let res = await installStoreBot(botId)
            if (res) {
                history.goBack()
            }
        } catch (error) {
            console.error(error)
            if (error.message) {
                setToast({
                    isOpen: true,
                    message: error.message,
                })
            }
        }
    }
    /** 查询我的机器人 */
    const queryMyBots = async () => {
        try {
            let res = await getMyBots()
            let latestBotInfo = res.data.filter((item) => item.id === bot.id)[0]
            if (!latestBotInfo && bot.status !== 0) {
                clearTimeout(udpateTimer)
                history.goBack()
                return
            }
            if (
                latestBotInfo &&
                (latestBotInfo.status === 1 ||
                    latestBotInfo.status === 4 ||
                    latestBotInfo.status === 5)
            ) {
                udpateTimer = setTimeout(() => {
                    queryMyBots()
                }, 1000)
            } else {
                clearTimeout(udpateTimer)
                latestBotInfo && setBotInfo(latestBotInfo)
            }
        } catch (error) {
            console.error(error)
        }
    }
    return (
        <IonPage>
            <IonContent className='bot-detail-content'>
                <Header title='应用详情' />
                <div className='bot-info'>
                    <img
                        className='bot-info_icon'
                        src={botInfo.logo_url || BotIcon}
                        alt='boticon'
                    />
                    <div className='bot-info-content'>
                        <div className='bot-info__title'>
                            <p className='text'>{botInfo.name}</p>
                            {/* 非移除中的机器人可以移除 */}
                            {botInfo.status !== 4 &&
                                botInfo.status !== 5 &&
                                botInfo.status !== 1 &&
                                !isStore && (
                                    <p
                                        className='delete-button option-button'
                                        onClick={() =>
                                            setAlertOptions({
                                                ...alertOptions,
                                                isOpen: true,
                                            })
                                        }
                                    >
                                        <span>移除</span>
                                    </p>
                                )}
                            {/* 移除中 */}
                            {botInfo.status === 4 && (
                                <p className='deletting-text option-button'>
                                    <span>移除中</span>
                                </p>
                            )}
                            {botInfo.status === 1 && (
                                <p className='adding-text option-button'>
                                    <span>添加中</span>
                                </p>
                            )}
                        </div>
                        <p className='bot-info__desc'>
                            <span>{botInfo.slogan}</span>
                        </p>
                        <p className='bot-info__author'>
                            开发者：{botInfo.author}
                        </p>
                    </div>
                </div>
                {botInfo.describe && (
                    <div className='bot-description'>
                        <p className='bot-description__title'>应用介绍</p>
                        <p className='bot-description__text'>
                            {botInfo.describe}
                        </p>
                    </div>
                )}
                {botInfo.example_list.length > 0 && (
                    <div className='bot-examples'>
                        <p className='bot-examples__title'>用法示例</p>
                        {botInfo.example_list.map((item, index) => (
                            <div className='bot-examples-content' key={index}>
                                <div className='bot-examples-left'>
                                    <span className='bot-examples__dot'></span>
                                </div>
                                <div className='bot-examples-right'>
                                    <div className='bot-examples-header'>
                                        <p className='bot-examples-header__title'>
                                            {item.name}
                                        </p>
                                        <p>：</p>
                                        <p className='bot-example-headers__desc'>
                                            {item.describe}
                                        </p>
                                    </div>
                                    <div className='bot-examples__list'>
                                        {item.examples.map((str, index) => (
                                            <p key={index}>{str}</p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                <div className='bot-detail-footer'>
                    {/* 存在新版本时可以更新 */}
                    {botInfo.has_new_version &&
                        botInfo.status !== 1 &&
                        !isStore && (
                            <IonButton
                                className={`button update ${
                                    botInfo.status === 5 && 'updating'
                                } option-button`}
                                onClick={() => {
                                    if (botInfo.status === 5) {
                                        return
                                    }
                                    handleBotAddOrUpdate(botInfo.id)
                                }}
                            >
                                <span>
                                    {botInfo.status === 5 ? '更新中' : '更新'}
                                </span>
                            </IonButton>
                        )}
                    {/* 问答机器人，且正在使用的机器人才能配置 */}
                    {botInfo.status === 2 && botInfo.bot_type === 1 && (
                        <IonButton
                            className='button'
                            onClick={() => {
                                history.push(BotKnowledgesPage, {
                                    rootTagId: botInfo.appid,
                                    botId: botInfo.id,
                                } as any)
                            }}
                        >
                            配置
                        </IonButton>
                    )}
                    {botInfo.status === 0 && isStore && (
                        <IonButton
                            className='button'
                            onClick={() => handleBotAddOrUpdate(botInfo.id)}
                        >
                            添加
                        </IonButton>
                    )}
                </div>
                <IonAlert
                    {...alertOptions}
                    buttons={[
                        {
                            text: '取消',
                            handler: () => {
                                setAlertOptions({
                                    ...alertOptions,
                                    isOpen: false,
                                })
                            },
                        },
                        {
                            text: '确认',
                            handler: () => {
                                setAlertOptions({
                                    ...alertOptions,
                                    isOpen: false,
                                })
                                handleBotRemove()
                            },
                        },
                    ]}
                />
                <Toast
                    {...toast}
                    color='success'
                    position='top'
                    onClose={() => setToast({ ...toast, isOpen: false })}
                />
            </IonContent>
        </IonPage>
    )
}

export default BotDetail
